import { render, staticRenderFns } from "./InsufficientCreditDialog.vue?vue&type=template&id=35ec6000&scoped=true&"
import script from "./InsufficientCreditDialog.vue?vue&type=script&lang=js&"
export * from "./InsufficientCreditDialog.vue?vue&type=script&lang=js&"
import style0 from "./InsufficientCreditDialog.vue?vue&type=style&index=0&id=35ec6000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec6000",
  null
  
)

export default component.exports